import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AssignmentIcon from "@material-ui/icons/Assignment";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DevicesOtherIcon from "@material-ui/icons/DevicesOther";
import SettingsIcon from "@material-ui/icons/Settings";
import TimelineIcon from "@material-ui/icons/Timeline";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../redux/actions/sidebarActions";
import { removeUserSession } from "../Utils/Common";
import { useStyles } from "../Utils/Styles";

export default function AdminSidebarList() {
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  return (
    <div>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary={t("adminSideBar.controlPanel")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/companies");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary={t("adminSideBar.companies")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/devices");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <DevicesOtherIcon />
        </ListItemIcon>
        <ListItemText primary={t("adminSideBar.devices")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/users");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <TimelineIcon />
        </ListItemIcon>
        <ListItemText primary={t("adminSideBar.users")} />
      </ListItem>

      <ListItem button>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary={t("adminSideBar.settings")} />
      </ListItem>
      <ListItem
        button
        className={classes.sideBarButton}
        onClick={() => {
          history.push("/login");
          removeUserSession();
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary={t("topbar.logout")} />
      </ListItem>
    </div>
  );
}
